import { OnDestroyHookDirective } from '../../shared/hooks';
import { Directive, Input } from '@angular/core';
import { PublicWifiAccount } from '../store/reducers/public-wifi.reducer';

@Directive()
export abstract class PublicWifiAccountFormDirective extends OnDestroyHookDirective {
  @Input()
  account: PublicWifiAccount;

  isLoginValid = false;
  isLoginModified = false;
  login: string;

  isPasswordValid = false;
  isConfirmPasswordValid = false;
  password: string;
  confirmPassword: string;

  protected constructor() {
    super();
  }

  validateLogin() {
    const regexp = new RegExp('^[A-Za-z0-9_.-]{1,40}$');
    this.isLoginValid = regexp.test(this.login);
    this.isLoginModified =
      this.login !== this.getValueWithoutDomain(this.account.login);
  }

  validatePassword() {
    const regexp = new RegExp(
      '^(?=.*[a-zA-Z])(?=.*\\d)[A-Za-z0-9@#(){}\\[\\]$._=+-]{8,8}$',
    );
    this.isPasswordValid = regexp.test(this.password);
    this.validateConfirmPassword();
  }

  validateConfirmPassword() {
    this.isConfirmPasswordValid = this.password === this.confirmPassword;
  }

  protected getValueWithoutDomain(value: string) {
    return value && value.split('@')[0];
  }

  protected shouldShowAlert(res: {
    value: boolean;
    selectedTechnicalLoginId: string;
  }) {
    return (
      this.getValueWithoutDomain(this.account.technicalLoginId) ===
        res.selectedTechnicalLoginId && res.value
    );
  }

  protected resetForm() {
    this.login = undefined;
    this.password = undefined;
    this.confirmPassword = undefined;
    this.isLoginValid = false;
    this.isLoginModified = false;
    this.isPasswordValid = false;
    this.isConfirmPasswordValid = false;
  }
}
